// Import model
import { BomKitCondition } from '../models/BomKitCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { BomKitIndexedFields } from '../models/BomKitIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { BomKitIndexedFieldsSerializer } from './BomKitIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for BomKitCondition - handles JSON serialization and deserialization with type validation
 */
export class BomKitConditionSerializer {
  /**
   * Deserializes a JSON string into a BomKitCondition instance
   */
  static deserialize(json: string): BomKitCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a BomKitCondition instance
   */
  static fromObject(obj: any): BomKitCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to BomKitCondition');
    }


    const instance: BomKitCondition = {
      fieldName: obj['fieldName'] as BomKitIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of BomKitCondition instances
   */
  static deserializeArray(json: string): BomKitCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a BomKitCondition instance to a JSON string
   */
  static serialize(instance: BomKitCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a BomKitCondition instance to a plain object
   */
  static toObject(instance: BomKitCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of BomKitCondition instances to a JSON string
   */
  static serializeArray(instances: BomKitCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
